const Product = [
    {id: 1,
     image: require('../Picture/image-product-1.jpg')},
    {id: 2,
        image: require('../Picture/image-product-2.jpg')},
    {id: 3,
        image: require('../Picture/image-product-3.jpg')},

    {id: 4,
        image: require('../Picture/image-product-4.jpg')},


  ];



export default Product